import API from "../utils/api";


const getCustomers = async () => {
  const res = await API.get(`/api/customers`);
  return res.data;
};
const createCustomer = async (data) => {
  const res = await API.post(`/api/customers`, data);
  return res.data;
};
const getSingleCustomer = async (id) => {
  const res = await API.get(`/api/customers/${id}`);
  return res.data;
};
const updateCustomer = async (id, data) => {
  const res = await API.put(`/api/customers/${id}`, data);
  return res.data;
};
const deleteCustomer = async (id) => {
  const res = await API.delete(`/api/customers/${id}`);
  return res.data;
};

const customerService = {
  getCustomers, createCustomer,
  getSingleCustomer, updateCustomer, deleteCustomer,
};
export default customerService;